// GiftModal.js
import giftService from 'pages/gift-module/services/gift.service';
import React from 'react';
import { Button, CloseButton } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { CSSTransition } from 'react-transition-group';
import StaticModal from 'shared/common/modal/staticModal';
import giftImage from '../../assets/images/gift3.png';

interface PropsType {
  redirectFunc?: any;
  showModal?: any;
  closeModal?: any;
  proceed?: any;
  cancel?: any;
  text?: any;
  keytext?: any;
  okButton?: any;
  cancelButton?: any;
  title?: any;
  corpGiftMessage?: any;
}
const GiftModal: React.FC<PropsType> = ({
  redirectFunc,
  showModal,
  closeModal,
  proceed,
  cancel,
  text,
  keytext,
  okButton,
  cancelButton,
  title,
  corpGiftMessage,
}) => {
  return (
    <StaticModal
      show={showModal}
      handleClose={() => cancel()}
      title={title}
      onClose={() => {
        cancel();
      }}
      // size='lg'

      center
    >
      <div className='position-relative'>
        {/* Close button is now absolutely positioned */}
        <div className='position-absolute top-0 end-0'>
          <CloseButton onClick={cancel} />
        </div>
      </div>
      {/* <div className='d-flex justify-content-end'>
        <CloseButton onClick={cancel} />
      </div> */}

      <div>
        <div className='RedeemMainDiv p-3'>
          <div className='row h-100'>
         
            <div className='col-12 col-md-4 d-flex align-items-center mb-3 mb-md-0'>
              <img
                src={giftImage}
                className='img-fluid'
                style={{ height: '160px', maxWidth: '100%', margin: '0 auto' }}
              />
            </div>

          
            <div className='col-12 col-md-8'>
              <h2 className='mb-3' style={{ color: '#301250' }}>
                <b>Congratulations 🎉</b>
              </h2>
              <h6
                className='text-1'
                style={{ fontWeight: 'bold' }}
              >
                {/* You've been gifted something special by your company🎁 */}
                {/* A special surprise is waiting just for you! */}
                You’ve been gifted something special.
              </h6>
              <p
                className='text-1'
                style={{ color: '#7f7a7a', fontSize: '14px' }}
              >
                {corpGiftMessage ? corpGiftMessage : null}
                {/* : 'Wishing you a Happy Diwali and continued success in the future. Enjoy your gift and thank you for being a part of our journey!'} */}
              </p>

              <div className='d-flex justify-content-center justify-content-md-start'>
                <Button
                  className='btn'
                  style={{ backgroundColor: '#301250', border: 'none' }}
                  onClick={proceed}
                >
                  Claim Now
                </Button>
              </div>
            </div>
          </div>
          {/* <div className=''>
            <h2 className='mb-3 text-center' style={{ color: '#301250' }}>
              <i>Congratulations!</i>
            </h2>
            <div className='container'>
              <h6 className='text-1' style={{ fontWeight: 'bold' }}>
                You have been gifted something special by your company🎁
              </h6>
              <p
                className='text-1'
                style={{ color: '#7f7a7a', fontSize: '14px' }}
              >
                {corpGiftMessage
                  ? corpGiftMessage
                  : 'Wishing you a Happy Diwali and continued success in the future. Enjoy your gift and thank you for being a part of our journey!'}
              </p>
            </div>

            <div className='d-flex justify-content-center '>
              <Button
                className='btn'
                style={{ backgroundColor: '#301250', border: 'none' }}
                onClick={proceed}
              >
                Claim Now
              </Button>
            </div>
          </div> */}
        </div>
      </div>
    </StaticModal>
  );
};

export default GiftModal;
